import Vue from 'vue'
import App from '@/views/paymentService/List/Index.vue'
import i18nSetting from '@/utils/languageSet'
import LangConfig from '@/locale/export/paymentServiceList.js'
import InitVue from '@/entries/initVue'
import { DialogBox } from '@/components'
import '@/utils/rem.js'
import '@/style/index.scss'

const i18n = i18nSetting(LangConfig) // 多语言实例
Vue.config.productionTip = false // 关闭提示
Vue.prototype.$DialogBox = DialogBox

InitVue().then(() => {
  new Vue({
    i18n,
    render: h => h(App)
  }).$mount('#app')
})
